/**
 * Mounted once (FlowSidebar): when someone leaves a shared project they changed (utils/handoffLeave.js), offers
 * "Leave a note" for the next collaborator.
 */
import React, { useEffect, useState } from 'react';
import { onLeaveOffer } from '../../utils/handoffLeave';
import { plural } from '../../utils/changesModel';
import { HandoffDialog } from './Handoff';

export default function LeaveNotePrompt() {
  const [offer, setOffer] = useState(null);
  useEffect(() => onLeaveOffer(setOffer), []);
  if (!offer) { return null; }
  return (
    <HandoffDialog
      intro={`You made ${plural(offer.count, 'change')} in ${offer.name || 'this shared project'} since you arrived. A short note helps whoever comes next.`}
      isOpen
      onClose={() => setOffer(null)}
      projectId={offer.projectId}
      projectName={offer.name}
      since={offer.since}
    />
  );
}
